import { useEffect, useState } from 'react';

import { SafeAreaInsetData } from '../../../capacitor_plugins/safeArea';
import { SAFE_AREA_CHANGED_EVENT } from './addCapacitorSafeAreaValues';
import safeAreaSingleton from './safeAreaSingleton';

/**
 * One safe area inset in px, re-rendering when it changes. Only for code that needs the value during
 * a render — `safeAreaSingleton.getSafeArea()` resolves asynchronously and cannot announce a change,
 * so a value read during a render stays stuck on 0. Prefer the singleton where it can be read late.
 */
const useSafeAreaInset = (side: keyof SafeAreaInsetData): number => {
    const [inset, setInset] = useState(safeAreaSingleton.getSafeArea()[side]);

    useEffect(() => {
        const onSafeAreaChanged = () => setInset(safeAreaSingleton.getSafeArea()[side]);

        // Picks up the new side immediately when `side` changes, rather than on the next event
        onSafeAreaChanged();

        window.addEventListener(SAFE_AREA_CHANGED_EVENT, onSafeAreaChanged);

        return () => window.removeEventListener(SAFE_AREA_CHANGED_EVENT, onSafeAreaChanged);
    }, [side]);

    return inset;
};

export default useSafeAreaInset;
